export const setArrayValue = (searchFilterProp, queryName) => {
  let result = '';
  if (searchFilterProp && searchFilterProp.length > 0) {
    searchFilterProp.forEach((x) => {
      result += x ? `&${queryName}=${x}` : '';
    });
  }
  return result;
};
